import { PaymentMethodPreset } from '@cpce/database/enums';
import type { BilletterieOrder } from '@cpce/shared';
import type { CustomerPaymentMode } from '@cpce/ticketing-api';

export const CUSTOMER_PAYMENT_MODES: Record<
  CustomerPaymentMode,
  { label: string; preset: PaymentMethodPreset }
> = {
  carte: { label: 'Carte bancaire', preset: PaymentMethodPreset.carteEncaissee },
  cheque: { label: 'Chèque', preset: PaymentMethodPreset.chequeEncaisse },
  especes: { label: 'Espèces', preset: PaymentMethodPreset.especes },
};

const CLOSED_ORDER_STATES = new Set(['cancelled', 'refunded']);

/** A deferred order the billetterie has not cancelled: the salarié owes the CSE for it. */
export const isAttachable = (order: BilletterieOrder) =>
  order.isDeferredPayment &&
  !CLOSED_ORDER_STATES.has(order.state) &&
  !CLOSED_ORDER_STATES.has(order.paymentState);

export const describePaymentMethods = (order: BilletterieOrder) =>
  order.paymentMethods.map((method) => method.label).join(' + ') || '-';

export const reglementLabel = (order: BilletterieOrder) =>
  `Pass CE - commande ${order.number ?? order.id}`;
